import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function fmtDate(dt) {
  try {
    return new Date(dt).toLocaleString("en-AU", { dateStyle: "medium", timeStyle: "short" });
  } catch {
    return dt;
  }
}

export const AssessmentsTab = ({ pw }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    axios
      .get(`${API}/admin/assessments`, { headers: { "X-Admin-Password": pw } })
      .then((res) => active && setData(res.data))
      .catch(() => toast.error("Failed to load assessments"))
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
  }, [pw]);

  if (loading) return <p className="text-center text-[#6F8FA8] py-20">Loading assessments…</p>;
  if (!data) return null;

  const { assessments, paid_count, revenue, converted_count } = data;

  return (
    <div>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-8">
        {[
          { k: "revenue", label: "Assessment revenue (AUD)", v: `$${revenue.toLocaleString(undefined, { maximumFractionDigits: 2 })}` },
          { k: "paid", label: "Assessments sold", v: paid_count },
          { k: "converted", label: "Went on to buy a package", v: converted_count },
        ].map((s) => (
          <div key={s.k} data-testid={`admin-assessments-stat-${s.k}`} className="bg-white rounded-2xl p-5 border border-[#E4E7EA]">
            <p className="text-xs uppercase tracking-wider text-[#6F8FA8] font-semibold">{s.label}</p>
            <p className="font-display text-4xl font-extrabold text-[#0D2F4D] mt-2">{s.v}</p>
          </div>
        ))}
      </div>

      {assessments.length === 0 ? (
        <div className="bg-white rounded-2xl p-12 text-center border border-[#E4E7EA]">
          <p className="text-[#6F8FA8]">No assessments purchased yet.</p>
        </div>
      ) : (
        <div className="space-y-3">
          {assessments.map((a) => (
            <div
              key={a.session_id}
              data-testid={`admin-assessment-row-${a.session_id}`}
              className="bg-white rounded-2xl px-6 py-4 border border-[#E4E7EA] flex flex-wrap items-center gap-x-6 gap-y-2"
            >
              <div className="min-w-[180px]">
                <p className="font-display font-bold text-[#0D2F4D]">{a.first_name}</p>
                <a href={`mailto:${a.email}`} className="text-sm text-[#6F8FA8] hover:text-[#0D2F4D]">
                  {a.email}
                </a>
              </div>
              <div className="text-sm min-w-[130px]">
                <p className="text-xs uppercase text-[#6F8FA8] font-semibold">Destination</p>
                <p className="font-semibold text-[#0D2F4D]">{a.destination_city || "—"}</p>
              </div>
              <div className="text-sm flex-1 min-w-[160px]">
                <p className="text-xs uppercase text-[#6F8FA8] font-semibold">Recommended</p>
                <p className="font-semibold text-[#0D2F4D]">{a.recommended_package_title || "—"}</p>
              </div>
              <p className="text-xs text-[#6F8FA8]">{fmtDate(a.purchased_at)}</p>
              {!a.had_questionnaire && (
                <span className="text-xs font-bold px-3 py-1.5 rounded-full bg-[#FFF3E6] text-[#A4621B]">
                  NO QUESTIONNAIRE
                </span>
              )}
              <span
                className={`text-xs font-bold px-3 py-1.5 rounded-full ${
                  a.package_purchased ? "bg-[#C6D21F] text-[#0D2F4D]" : "bg-[#ECF0F4] text-[#6F8FA8]"
                }`}
              >
                {a.package_purchased ? "PACKAGE PURCHASED ✓" : "NO PACKAGE YET"}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
